export default __webpack_public_path__ + "static/media/toyota-little-city.2aabbae0.svg";